import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { MessageService } from 'primeng/api';
import { ImageRequest } from 'src/app/interfaces/userchatcrm';
import { MessagesService } from 'src/app/service/messages.service';

@Component({
  selector: 'app-uploadmedia',
  templateUrl: './uploadmedia.component.html',
  styleUrls: ['./uploadmedia.component.scss'],
  providers: [MessageService]
})
export class UploadmediaComponent implements OnInit {
  uploadedFiles: any[] = [];
  maxFileSize:number = 1000000;
  multiple:boolean = false;
  isImage: boolean = false;
  @Output() fileUploaded: EventEmitter<void> = new EventEmitter<void>();
  @Output() imageUploaded: EventEmitter<void> = new EventEmitter<void>();
  @Output() imageSelected: EventEmitter<File> = new EventEmitter<File>();
  selectedImageUrl: string = ''; // Variable para almacenar la URL de la imagen seleccionada
  isPdfSelected: boolean = false;
  constructor(private messageService: MessageService, private messageServicio: MessagesService) { }

  ngOnInit(): void {
  }

  onUpload(event: { files: any; }) {
    for(let file of event.files) {
      this.uploadedFiles.push(file);
    }
    // Emite el archivo seleccionado (File) en lugar de la URL
    this.imageSelected.emit(event.files[0]);
    this.imageUploaded.emit();
  }
  

}
